/**
 * "몇 시간 전" 처럼 읽는 시간. 알림 줄에 쓴다.
 *
 * 일주일이 넘으면 날짜로 바꾼다 — "37일 전" 은 세어 보게 만들고, 그쯤
 * 되면 언제인지가 궁금한 것이지 며칠이 지났는지가 궁금한 게 아니다.
 * 해가 바뀌면 연도까지 적는다.
 */
export default function timeAgo(value, now = new Date()) {
  if (!value) return "";
  const then = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(then.getTime())) return "";

  const sec = Math.floor((now.getTime() - then.getTime()) / 1000);
  /* 기기 시계가 조금 앞서 있으면 음수가 나온다. 미래로 보이느니 '방금' 이 낫다. */
  if (sec < 60) return "방금";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}분 전`;
  const hour = Math.floor(min / 60);
  if (hour < 24) return `${hour}시간 전`;

  /* 날짜 경계로 센다. 어젯밤 11시와 오늘 새벽 1시는 두 시간 차이지만 '어제' 다. */
  const day0 = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((day0(now) - day0(then)) / 86400000);
  if (days <= 1) return "어제";
  if (days <= 7) return `${days}일 전`;

  const md = `${then.getMonth() + 1}월 ${then.getDate()}일`;
  return then.getFullYear() === now.getFullYear() ? md : `${then.getFullYear()}년 ${md}`;
}
